import { IAppState } from '../../../AppModulesWrapper';
import { selectActiveServiceId } from '../../reducers/v2/promotion/selectors';
import { EServiceId } from '../../types/reducers/publishTerms';

export const selectIsIncreaseToMinimalTopBet = (state: IAppState): boolean => {
  const activeServiceId = selectActiveServiceId(state);

  return activeServiceId === EServiceId.top;
};
